"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TabHeader = void 0;
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _Tabs = require("../Tabs.types");
require("./TabHeader.scss");
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj["default"] = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
var HOVER_DELAY = 200;
var TabHeader = function TabHeader(_ref) {
  var title = _ref.title,
    isActive = _ref.isActive,
    onTrigger = _ref.onTrigger,
    _ref$triggerType = _ref.triggerType,
    triggerType = _ref$triggerType === void 0 ? _Tabs.TABS_TRIGGER_TYPE.click : _ref$triggerType,
    className = _ref.className;
  var rootClassName = (0, _classnames["default"])('cds-Tab', {
    'cds-Tab--Active': isActive
  }, className);
  var timeoutIdRef = (0, _react.useRef)(null);
  var handleHover = function handleHover(title) {
    switch (triggerType) {
      case _Tabs.TABS_TRIGGER_TYPE.none:
        break;
      case _Tabs.TABS_TRIGGER_TYPE.hover:
        onTrigger(title);
        break;
      case _Tabs.TABS_TRIGGER_TYPE.hoverDelayed:
        if (timeoutIdRef) {
          timeoutIdRef.current = setTimeout(function () {
            return onTrigger(title);
          }, HOVER_DELAY);
        }
        break;
    }
  };
  var handleClick = function handleClick(title) {
    if (triggerType !== _Tabs.TABS_TRIGGER_TYPE.none) {
      onTrigger(title);
    }
  };
  return /*#__PURE__*/_react["default"].createElement("li", {
    className: rootClassName,
    onClick: function onClick() {
      return handleClick(title);
    },
    onMouseEnter: function onMouseEnter() {
      return handleHover(title);
    },
    onMouseLeave: function onMouseLeave() {
      return clearTimeout(timeoutIdRef === null || timeoutIdRef === void 0 ? void 0 : timeoutIdRef.current);
    }
  }, title);
};
exports.TabHeader = TabHeader;